export const BU_PROGRESS_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_PROGRESS_SIZES = [
  'small',
  'medium',
  'large'
];
